/*
 * SpawnOS funnel instrumentation for blackwateraquatics.ca.
 *
 * Any element carrying data-spawnos-placement is measured:
 *   spawnos_impression      — at least half of it was on screen (once per page)
 *   spawnos_cta_click       — a link marked data-spawnos-cta (not the App Store)
 *   spawnos_appstore_click  — a link marked data-spawnos-cta="appstore"
 *
 * Each event goes to three places:
 *   - window.BWTrack.event   (the theme's existing dataLayer + Shopify customer events)
 *   - Microsoft Clarity      (custom event, so recordings can be filtered by it)
 *   - https://spawnos.ca/api/funnel  (first-party ledger — the only one of the
 *                                     three that is currently readable)
 *
 * Nothing personal is sent: event name, page path, page type and placement.
 * Theme previews and ?funnel_test=1 are flagged is_test so QA never counts.
 *
 * Loaded by snippets/bwa-spawnos-funnel.liquid, possibly more than once on a
 * page (card + contextual module) — the guard makes it initialise exactly once.
 */
(function () {
  if (window.__bwaSpawnosFunnel) return;
  window.__bwaSpawnosFunnel = true;

  var LEDGER = 'https://spawnos.ca/api/funnel';

  // QA and admin traffic must never count as real funnel data:
  //  - any theme that is not the published one (staging previews). Checked via
  //    Shopify.theme.role, NOT the URL: Shopify 302s ?preview_theme_id= away
  //    and keeps the preview in a cookie, so the query string is gone by the
  //    time this runs.
  //  - the theme editor (Shopify.designMode)
  //  - an explicit ?funnel_test=1, remembered for the rest of the session
  function isTest() {
    try {
      var S = window.Shopify || {};
      if (S.designMode) return true;
      if (S.theme && S.theme.role && S.theme.role !== 'main') return true;
      if (/[?&]funnel_test=1\b/.test(window.location.search)) sessionStorage.setItem('bwa_funnel_test', '1');
      return sessionStorage.getItem('bwa_funnel_test') === '1';
    } catch (e) {
      return false;
    }
  }

  function send(name, el) {
    var data = {
      event: name,
      site: 'blackwater',
      page_path: window.location.pathname,
      page_type: el.getAttribute('data-spawnos-page-type') || null,
      placement: el.getAttribute('data-spawnos-placement') || null,
      is_test: isTest()
    };
    try {
      if (window.BWTrack && typeof window.BWTrack.event === 'function') {
        window.BWTrack.event(name, { placement: data.placement, page_type: data.page_type });
      }
    } catch (e) {}
    try {
      if (typeof window.clarity === 'function') window.clarity('event', name);
    } catch (e) {}
    try {
      if (navigator.sendBeacon) navigator.sendBeacon(LEDGER, JSON.stringify(data));
    } catch (e) {}
  }

  function init() {
    var units = document.querySelectorAll('[data-spawnos-placement]');
    if (!units.length) return;

    // Impressions: half the unit visible, counted once per unit per page.
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting && entry.intersectionRatio >= 0.5) {
            send('spawnos_impression', entry.target);
            io.unobserve(entry.target);
          }
        });
      }, { threshold: [0.5] });
      units.forEach(function (u) { io.observe(u); });
    }

    // Clicks: capture phase, so the beacon leaves before the new tab opens.
    document.addEventListener('click', function (e) {
      var link = e.target.closest && e.target.closest('a[data-spawnos-cta]');
      if (!link) return;
      var unit = link.closest('[data-spawnos-placement]');
      if (!unit) return;
      var kind = link.getAttribute('data-spawnos-cta');
      send(kind === 'appstore' ? 'spawnos_appstore_click' : 'spawnos_cta_click', unit);
    }, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
